
import { Link } from "react-router-dom";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

interface PostHeaderProps {
  profile: {
    id: string;
    username: string;
    avatar_url: string;
  };
  createdAt: string;
}

export function PostHeader({ profile, createdAt }: PostHeaderProps) {
  return (
    <div className="flex items-center gap-3">
      <Link to={`/profile/${profile.id}`}>
        <Avatar>
          <AvatarImage src={profile.avatar_url} />
          <AvatarFallback>{profile.username?.charAt(0).toUpperCase()}</AvatarFallback>
        </Avatar>
      </Link>
      <div>
        <Link to={`/profile/${profile.id}`} className="hover:underline">
          <h3 className="font-medium">{profile.username}</h3>
        </Link>
        <p className="text-sm text-muted-foreground">
          {new Date(createdAt).toLocaleDateString()}
        </p>
      </div>
    </div>
  );
}
